import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../_helpers/auth.guard';

import { AdminDefaultComponent } from './admin-default/admin-default.component';
import { CompaniesComponent } from './companies/companies.component';
import { UsersComponent } from './users/users.component';

const routes: Routes = [
  { 
	path: 'administrator', component: AdminDefaultComponent, children: [
	  { 
      path: '', 
      component: CompaniesComponent,
      canActivate: [AuthGuard],
      data: { page: 'administrator', roles: ['master'] }
    },
	  { 
      path: 'companies', 
      component: CompaniesComponent,
      data: { page: 'companies', roles: ['master'] }
    },
    { 
      path: 'users', 
      component: UsersComponent,
      data: { page: 'companies', roles: ['master'] }
    },
	]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministratorRoutingModule { }
